module.exports = __webpack_public_path__ + "img/pc.0bac2720.png";